import { render, staticRenderFns } from "./YourAccountComplete.vue?vue&type=template&id=23366c84&scoped=true&"
import script from "./YourAccountComplete.vue?vue&type=script&lang=ts&"
export * from "./YourAccountComplete.vue?vue&type=script&lang=ts&"
import style0 from "./YourAccountComplete.vue?vue&type=style&index=0&id=23366c84&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23366c84",
  null
  
)

export default component.exports